<template>
  <div :class="containerClass + ' container' + ' add-remove-com'">
    <h2 class="text-secondary">{{ $t(title) }} </h2>
    <div class="flex add-item" v-for="item in data">
      <img class="member-status" v-if="item.memberStatus" width="30"
        :src="fit20.storageBaseUrl + '/member/' + (item.memberStatus == 'member' ? 'member1' : item.memberStatus.toLowerCase()) + '.png'" />
      <div :class="['item pointer', { 'main': item.main }]" @click="selectItem(item.id)">{{ name2 ? item[name1] + " " +
        item[name2] : item[name1] }}
      </div>
      <img width="50" :src="fit20.storageBaseUrl + '/static/icons/x.svg'" @click="removeItem(item.id)" />
    </div>
    <img width="50" :src="fit20.storageBaseUrl + '/static/icons/%2B.png'"
      @click="togglePopup(popupParams[0], popupParams[1], popupParams[2])" />
  </div>
</template>

<script>
export default {
  name: 'AddRemoveItem',
  props: ["containerClass", "title", "data", "selectItem", "removeItem", "togglePopup", "popupParams", "name1", "name2", "fit20"],
};
</script>

<style>
.add-remove-com.container {
  margin-top: 10px;
}

.add-remove-com .main {
  background-color: var(--fit20-green);
}

.add-remove-com .item {
  width: 70%;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 7px 7px 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.add-remove-com img {
  margin-bottom: 7px;
}

.add-remove-com .member-status {
  padding: 5px 2px;
}
</style>
